import React from 'react';

export default function BacktestChartLegend({ items = [], colors }) {
  if (!items.length) return null;
  return (
    <ul
      data-testid="backtest-chart-legend"
      aria-label="Chart legend"
      style={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 2,
        margin: 0,
        padding: '6px 8px',
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        pointerEvents: 'none',
        background: `${colors.bgCard || colors.bgPrimary}E6`,
        border: `1px solid ${colors.border}`,
        borderRadius: 6,
        color: colors.text,
        fontSize: 11,
        lineHeight: 1.2,
      }}
    >
      {items.map((item) => (
        <li key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          {item.kind === 'fvg' ? (
            <span aria-hidden="true" style={{ display: 'flex', width: 12, height: 8, borderRadius: 1, overflow: 'hidden' }}>
              <span style={{ flex: 1, background: colors.success }} />
              <span style={{ flex: 1, background: colors.danger }} />
            </span>
          ) : item.kind === 'session' ? (
            <span
              aria-hidden="true"
              style={{
                width: 12,
                height: 8,
                borderRadius: 1,
                background: `${item.color}24`,
                border: `1px solid ${item.color}`,
                boxSizing: 'border-box',
              }}
            />
          ) : (
            <span
              aria-hidden="true"
              style={{
                width: 12,
                borderTop: `${item.dashed ? 1.5 : 2}px ${item.dashed ? 'dashed' : 'solid'} ${item.color}`,
              }}
            />
          )}
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
